import NavbarSidebarWrapper from "../../components/navbarSidebarWrapper";
import { useCallback, useEffect, useState } from "react";
import actions from "../../redux/actions";
import { useSelector } from "react-redux";
import ScreenLoader from "../../components/ScreenLoader";
import { isRoleExits } from "../../utils";
import TableWrapper from "../../components/CreateFantacyMatch/TableWrapper";
import { notifyError, notifySuccess } from "../../components/ToastContext";

const CreateFantacyMatch = () => {
  let data = useSelector((state) => state.fantacyMatch?.matchScheduleList);
  let marketIdsList = useSelector((state) => state.match?.marketIdsList?.Result);
  const [action, setAction] = useState(true);
  const [loader, setLoader] = useState(true);
  const [selectedMatchIds, setSelectedMatchIds] = useState([]);


  const handleScheduleList = async () => {
    setLoader(true);
    try {
      let res = await actions.getScheduleList();
      console.log("data",data);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Failed to load schedule");
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Failed to load schedule");
    }
    setLoader(false);
  };
  useEffect(() => {
    handleScheduleList();
  }, []);

  const onSelectionChange = useCallback((ids) => {
    setSelectedMatchIds(ids);
  }, []);

  const handleSave = async () => {
    console.log("Selected Match IDs:", selectedMatchIds);
    setLoader(true);
    setAction((prevState) => !prevState);
    try {
      let res = await actions.postSaveSchedule(selectedMatchIds);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Save failed");
      } else {
        notifySuccess("Schedule saved successfully");
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || err.message || "Save failed");
    }
    setLoader(false);
  };


  return (
    <NavbarSidebarWrapper>
      <div>
        <div className="content-header-btn mb-2">
          Create Fantacy Match
        </div>
        <div className="tab-content">
          <div className="text-right w-100">
            {(isRoleExits("matchmanual") ||
              isRoleExits("addmatch")) && (
                <button
                  className={selectedMatchIds.length > 0 ? "back-btn mb-1" : "mb-1"}
                  disabled={selectedMatchIds.length === 0}
                  onClick={handleSave}
                >
                  Save Selected Match({selectedMatchIds.length})
                </button>
              )}
          </div>
          <div className="tab-pane fade show active" id="tab2">
            <TableWrapper
              data={data}
              marketIdsList={marketIdsList}
              showAction={action}
              onSelectionChange={onSelectionChange} />
          </div>
          {loader && <ScreenLoader />}
        </div>
      </div>
    </NavbarSidebarWrapper>
  );
};

export default CreateFantacyMatch;
